// extracted by mini-css-extract-plugin
module.exports = {"animalList":"LicenseWarnings_animalList__2-eRl"};